import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import { X } from 'lucide-react'
import { useLocalized } from '@/i18n/useLocalized'
import { useLang } from '@/i18n/useLang'

const DISMISS_KEY = 'achp-announce-vol2-2026'

export function AnnouncementBar() {
  const { t } = useLang()
  const L = useLocalized()
  const [hidden, setHidden] = useState(() => {
    try {
      if (typeof window === 'undefined') return false
      return localStorage.getItem(DISMISS_KEY) === '1'
    } catch {
      return false
    }
  })

  if (hidden) return null

  const dismiss = () => {
    setHidden(true)
    try {
      localStorage.setItem(DISMISS_KEY, '1')
    } catch {
      /* ignore */
    }
  }

  return (
    <div className="announce">
      <div className="container announce-inner">
        <Link to={L('/books')} className="announce-link">
          <img src="/logo-ocm-kpm.png" alt="" aria-hidden="true" className="pill-mark" />
          <span className="badge-soft" style={{ padding: '3px 9px' }}>{t.announce.badge}</span>
          <span className="announce-text">{t.announce.text}</span>
          <span className="announce-cta">{t.announce.cta} →</span>
        </Link>
        <button type="button" className="announce-close" onClick={dismiss} aria-label={t.announce.badge === 'New' ? 'Dismiss announcement' : 'Скрыть анонс'}>
          <X size={15} aria-hidden="true" />
        </button>
      </div>
    </div>
  )
}
